import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/platform/users')({
  staticData: { crumb: 'Users' },
})
